import { createContext } from 'react';

const MetaContext = createContext({ error: null, readOnly: true });

export default MetaContext;
